/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TlsModeFromJSON, TlsModeToJSON, } from './TlsMode';
/**
 * Check if a given object implements the TestLdapServerRequest interface.
 */
export function instanceOfTestLdapServerRequest(value) {
    if (!('host' in value) || value['host'] === undefined)
        return false;
    if (!('port' in value) || value['port'] === undefined)
        return false;
    if (!('bindDn' in value) || value['bindDn'] === undefined)
        return false;
    if (!('bindPassword' in value) || value['bindPassword'] === undefined)
        return false;
    if (!('tlsMode' in value) || value['tlsMode'] === undefined)
        return false;
    if (!('tlsVerify' in value) || value['tlsVerify'] === undefined)
        return false;
    return true;
}
export function TestLdapServerRequestFromJSON(json) {
    return TestLdapServerRequestFromJSONTyped(json, false);
}
export function TestLdapServerRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'host': json['host'],
        'port': json['port'],
        'bindDn': json['bind_dn'],
        'bindPassword': json['bind_password'],
        'tlsMode': TlsModeFromJSON(json['tls_mode']),
        'tlsVerify': json['tls_verify'],
    };
}
export function TestLdapServerRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'host': value['host'],
        'port': value['port'],
        'bind_dn': value['bindDn'],
        'bind_password': value['bindPassword'],
        'tls_mode': TlsModeToJSON(value['tlsMode']),
        'tls_verify': value['tlsVerify'],
    };
}
